import { render, staticRenderFns } from "./ProductData.vue?vue&type=template&id=e515c3fe&"
import script from "./ProductData.vue?vue&type=script&lang=js&"
export * from "./ProductData.vue?vue&type=script&lang=js&"
import style0 from "./ProductData.vue?vue&type=style&index=0&id=e515c3fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports